import React from 'react';
import PropTypes from 'prop-types';
import Dashboard from './Dashboard';

class UserLookup extends React.Component{

    lookupUser = (e) => {
        e.preventDefault();
        const email = this.emailRef.value;
        this.props.lookupUser(email);
    };

    render() {
        return (
            <div>
                <h4 className="no-print">User lookup</h4>
                <form className="lookupForm no-print" onSubmit={e => this.lookupUser(e)}>
                    <input className="input-lookup" ref={input => this.emailRef = input} disabled={this.props.disableUserLookup} placeholder="Enter email address"/>
                    <button type="submit" className="btn btn-primary btn-right btn-lookup btn-with-icon" disabled={this.props.disableUserLookup}>
                        <i className={`material-icons ${this.props.disableUserLookup ? '' : 'hidden'}`}>loop</i>
                        <span className={this.props.disableUserLookup ? 'hidden' : ''}><i className="material-icons">search</i>Find user</span>
                    </button>
                </form>
                {Object.keys(this.props.user).length === 0 ? null : <Dashboard user={this.props.user} appts={this.props.appts} products={this.props.products} renderTags={this.props.renderTags} addTags={this.props.addTags} removeTags={this.props.removeTags} filterProducts={this.props.filterProducts} userProductSearch={this.props.userProductSearch} payments={this.props.payments} freshdeskID={this.props.freshdeskID}/>}
            </div>
        );
    }
}

UserLookup.propTypes = {
    lookupUser: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    userProductSearch: PropTypes.string.isRequired,
    products: PropTypes.object.isRequired,
    disableUserLookup: PropTypes.bool.isRequired,
    addTags: PropTypes.func.isRequired,
    removeTags: PropTypes.func.isRequired,
    filterProducts: PropTypes.func.isRequired,
    appts: PropTypes.array.isRequired,
    freshdeskID: PropTypes.string
}

export default UserLookup;


/** WEBPACK FOOTER **
 ** ./src/components/UserLookup.js
 **/